"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDate = formatDate;
var date_fns_1 = require("date-fns");
function formatDate(dateString) {
    return (0, date_fns_1.format)(new Date(dateString), "dd MMM yyyy");
}
